import { endFromStart, durationFromTimes, clampEnd, durationLabel, MIN_DURATION_MINUTES } from '../helpers/eventTime';

export const EventTimeMixin = {
  data() {
    return {
      durationMinutes: MIN_DURATION_MINUTES,
    };
  },

  methods: {
    // Call when opening the modal, after start_time/end_time are set.
    initEventTimes(startHHMM, endHHMM) {
      this.start_time = startHHMM;
      this.end_time = endHHMM;
      const d = durationFromTimes(startHHMM, endHHMM);
      this.durationMinutes = d >= MIN_DURATION_MINUTES ? d : MIN_DURATION_MINUTES;
    },

    // Bound to the start <input type="time"> — shifts end to preserve duration.
    onStartTimeChange(value) {
      this.start_time = value;
      this.end_time = endFromStart(value, this.durationMinutes);
    },

    // Bound to the end <input type="time"> — keeps start, recomputes duration.
    onEndTimeChange(value) {
      this.end_time = clampEnd(this.start_time, value);
      this.durationMinutes = durationFromTimes(this.start_time, this.end_time);
    },

    applyDurationPreset(minutes) {
      this.durationMinutes = minutes;
      this.end_time = endFromStart(this.start_time, minutes);
    },
  },

  computed: {
    durationLabelText() {
      return durationLabel(this.durationMinutes);
    },
  },
};
